import { VesselCardEvaluationReason } from "../models/vessel-card-evaluation.models";

// Uses provisional reasons until the DVP team confirms its request categories.
export const VESSEL_CARD_EVALUATION_REASONS: Array<{ value: VesselCardEvaluationReason; label: string }> = [
  { value: "fixture_review", label: "Fixture review" },
  { value: "performance_concern", label: "Performance concern" },
  { value: "new_vessel_information", label: "New vessel information" },
  { value: "other", label: "Other" },
];

export const VESSEL_CARD_EVALUATION_MAX_WORDS = 2000;
// Caps unusually long words and pasted payloads as well as enforcing the product's word limit.
export const VESSEL_CARD_EVALUATION_MAX_CHARACTERS = 100000;

// Applies provisional upload limits shared with the backend until business owners confirm them.
export const VESSEL_CARD_EVALUATION_MAX_FILES = 10;
export const VESSEL_CARD_EVALUATION_MAX_FILE_BYTES = 25 * 1024 * 1024;
export const VESSEL_CARD_EVALUATION_MAX_TOTAL_BYTES = 50 * 1024 * 1024;
export const VESSEL_CARD_EVALUATION_FILE_EXTENSIONS = [
  "pdf", "doc", "docx", "xls", "xlsx", "csv", "txt", "eml", "msg", "jpg", "jpeg", "png", "webp",
];
export const VESSEL_CARD_EVALUATION_FILE_ACCEPT = VESSEL_CARD_EVALUATION_FILE_EXTENSIONS.map((extension) => `.${extension}`).join(",");
